/* tslint:disable */
/* eslint-disable */
export enum WorkAiServiceProviderEnum {
  Infomaniak = 'infomaniak',
  OpenaiCompatible = 'openaiCompatible'
}
